
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"9","viewBox":"0 0 32 9","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.611 0L0 7.992h4.323l.536-1.274h1.226l.536 1.274h4.758v-.973l.424.973h2.462l.424-.993v.993h9.897l1.204-1.241 1.127 1.241 5.083.01-3.623-3.984L32 0h-5.005l-1.171 1.218L24.733 0H13.966l-.925 2.063L12.095 0H7.781v.94L7.3 0H3.61zm14.78 1.135h5.683l1.739 1.878 1.794-1.878h1.738l-2.641 2.882 2.641 2.85h-1.817l-1.738-1.9-1.804 1.9h-5.595V1.135zm1.403 2.235V2.322h3.547l1.547 1.674-1.616 1.683h-3.478V4.536h3.1V3.37h-3.1zM4.448 1.135h2.107l2.396 5.42v-5.42h2.308l1.85 3.886 1.706-3.886h2.297V6.87h-1.398l-.011-4.494-2.038 4.494h-1.25l-2.05-4.494V6.87H7.49l-.545-1.286H4L3.456 6.87h-1.54l2.532-5.734zm.055 3.261l.97-2.29.97 2.29h-1.94z","fill":"#fff"}})])
          )
        }
      }
    